module.exports = __webpack_public_path__ + "static/media/receipt-search.47d2e9bb.svg";